import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  fetchFilteredArticlesThunk,
  fetchFiltersListThunk,
  fetchRecentArticlesThunk,
  fetchDiscountedArticlesThunk,
} from "./articles.thunk";

// Wrap raw thunks into RTK async actions
export const fetchRecentArticles = createAsyncThunk(
  "articles/fetchRecentArticles",
  fetchRecentArticlesThunk
);
export const fetchFilteredArticles = createAsyncThunk(
  "articles/fetchFilteredArticles",
  fetchFilteredArticlesThunk
);
export const fetchFiltersList = createAsyncThunk(
  "articles/fetchFiltersList",
  fetchFiltersListThunk
);
export const fetchDiscountedArticles = createAsyncThunk(
  "articles/fetchDiscountedArticles",
  fetchDiscountedArticlesThunk
);

// Pagination metadata template
const metaFilter = {
  page: 1,
  take: 12,
  item_count: 0,
  page_count: 1,
  has_previous_page: false,
  has_next_page: false,
};

// Slice initial state
const initialState = {
  recent_articles: {
    list: [],
    is_fetch: false,
  },
  filtered_articles: {
    list: [],
    meta: metaFilter,
    is_fetch: false,
  },
  filters_list: {
    data: [],
    url_filters: [],
    is_fetch: false,
  },
  discounted_articles: {
    data: [],
    meta: metaFilter,
    is_fetch: false,
    is_loading: false,
  },
};

const articlesSlice = createSlice({
  name: "articles",
  initialState,
  reducers: {
    clearValues: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      // recent articles
      .addCase(fetchRecentArticles.pending, (state) => {
        state.recent_articles.is_fetch = false;
        state.recent_articles.list = [];
      })
      .addCase(fetchRecentArticles.fulfilled, (state, { payload }) => {
        state.recent_articles.is_fetch = true;
        state.recent_articles.list = payload;
      })
      .addCase(fetchRecentArticles.rejected, (state) => {
        state.recent_articles.is_fetch = false;
        state.recent_articles.list = [];
      })

      // filtered articles
      .addCase(fetchFilteredArticles.pending, (state) => {
        state.filtered_articles.is_fetch = false;
        state.filtered_articles.list = [];
        state.filtered_articles.meta = metaFilter;
      })
      .addCase(fetchFilteredArticles.fulfilled, (state, { payload }) => {
        state.filtered_articles.is_fetch = true;
        state.filtered_articles.list = payload.data;
        state.filtered_articles.meta = payload.meta;
      })
      .addCase(fetchFilteredArticles.rejected, (state) => {
        state.filtered_articles.is_fetch = false;
        state.filtered_articles.list = [];
        state.filtered_articles.meta = metaFilter;
      })

      // filters list
      .addCase(fetchFiltersList.pending, (state) => {
        state.filters_list.is_fetch = false;
        state.filters_list.data = [];
        state.filters_list.url_filters = [];
      })
      .addCase(fetchFiltersList.fulfilled, (state, { payload }) => {
        state.filters_list.is_fetch = true;
        state.filters_list.data = payload.data;
        state.filters_list.url_filters = payload.url_filters;
      })
      .addCase(fetchFiltersList.rejected, (state) => {
        state.filters_list.is_fetch = false;
        state.filters_list.data = [];
        state.filters_list.url_filters = [];
      })

      //discounted articles
      .addCase(fetchDiscountedArticles.pending, (state) => {
        state.discounted_articles.is_fetch = false;
        state.discounted_articles.is_loading = true;
        state.discounted_articles.data = [];
        state.discounted_articles.meta = metaFilter;
      })
      .addCase(fetchDiscountedArticles.fulfilled, (state, { payload }) => {
        state.discounted_articles.is_fetch = true;
        state.discounted_articles.is_loading = false;
        state.discounted_articles.data = payload.data;
        state.discounted_articles.meta = payload.meta;
      })
      .addCase(fetchDiscountedArticles.rejected, (state) => {
        state.discounted_articles.is_fetch = false;
        state.discounted_articles.is_loading = false;
        state.discounted_articles.data = [];
        state.discounted_articles.meta = metaFilter;
      });
  },
});

export const { clearValues } = articlesSlice.actions;
export default articlesSlice.reducer;
